import { useMutation } from 'react-query';
import http from '../http';

const createUobPointRedemption = ({
  mc_product,
}: CreateUobPointRedemptionPayload) =>
  http.post<CreateUobPointRedemptionPayload>('/v1/mc_products', mc_product);

export const useCreateUobPointRedemption = () =>
  useMutation(createUobPointRedemption);

export type CreateUobPointRedemptionPayload = {
  mc_product: FormData;
};
